import React from 'react';
import {parseTags} from '../../utils/parseTags';

const FormattedResponse = ({ response, isModal = false }) => {
  const {
    passage, conclusion, reasons, task,
    dialogCompleted, completionStatus, successText, summary, examples, completionMessage,
  } = parseTags(response);

  // Modal view — shown inside PerformanceSummaryModal
  if (isModal && dialogCompleted) {
    return (
      <div className="formatted-response modal-response">
        {/* Success or Failure badge */}
        {/*
        <div className={`completion-badge ${completionStatus}`}>
          {completionStatus === "success" ? "✓ Completed Successfully" : "✗ Not Completed"}
        </div>

        {successText && (
          <p className="success-feedback">{successText}</p>
        )}

        {summary && (
          <div className="modal-summary">
            <h4 className="modal-summary-title">Summary</h4>
            <p className="modal-summary-text">{summary}</p>
          </div>
        )} 
        */}

        {/* Examples */}
        {examples.length > 0 && (
          <div className="modal-examples">
            <p className="examples-intro">Please go through the below examples</p>
            <h4 className="modal-examples-title">Examples</h4>
            <ul className="modal-examples-list">
              {examples.map((example, idx) => (
                <li key={idx} className="modal-example-item">
                  <span className="example-bullet">•</span>
                  <span>{example}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="formatted-response">
      {/* Passage Section */}
      {passage && (
        <div className="section passage-section">
          <h3 className="section-title">Passage</h3>
          <p className="passage-text">{passage}</p>
        </div>
      )}

      {/* Conclusion Section */}
      {conclusion && (
        <div className="section conclusion-section">
          <div className="conclusion-label">CONCLUSION</div>
          <p className="conclusion-text">{conclusion}</p>
        </div>
      )}

      {/* Supporting Reasons Section */}
      {reasons.length > 0 && (
        <div className="section reasons-section">
          <div className="reasons-label">SUPPORTING REASONS</div>
          <ul className="reasons-list">
            {reasons.map((reason, idx) => (
              <li key={idx} className="reason-item">
                <span className="checkmark">✓</span>
                <span>{reason}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Task Section */}
      {task && (
        <div className="section task-section">
          <h3 className="section-title">Your task</h3>
          <p className="task-text">{task}</p>
        </div>
      )}

    </div>
  );
}

export default FormattedResponse;